export { ReactComponent as PriceIcon } from './price.svg';
export { ReactComponent as ShopIcon } from './shop.svg';
export { ReactComponent as CookIcon } from './cook.svg';
export { ReactComponent as DishIcon } from './dish.svg';
export { ReactComponent as FacebookIcon } from './facebook.svg';
export { ReactComponent as InstagramIcon } from './instagram.svg';
export { ReactComponent as LinkedInIcon } from './linkedin.svg';
export { ReactComponent as QuoteIcon } from './quote.svg';
